module.exports = __webpack_public_path__ + "img/noteicon.daf6bc4b.svg";